// extracted by mini-css-extract-plugin
export default {"container":"colored_container__WwrPR","cell":"colored_cell__E89bz"};